import React, { useContext, useEffect, useSyncExternalStore } from 'react'
import { ChatStatusType, ChatStoreContext } from './ChatStoreContext'

import { UserContext } from '../../../context'
import { chatStore } from '@/components/chat/ChatStore/ChatStore'
import { ChatSendMessageToastProvider } from '@/components/chat/ChatSendMessageToast/ChatSendMessageToastProvider'
import { ChatSendMessageToast } from '@/components/chat/ChatSendMessageToast/ChatSendMessageToast'
import { useRouter } from 'next/router'

export const ChatStoreProvider = ({ children }) => {
  const { user } = useContext(UserContext)
  const chatState = useSyncExternalStore(
    chatStore.subscribe,
    chatStore.getSnapshot
  )
  const connectionChannels = useSyncExternalStore(
    chatStore.connectionChannelsCollection.subscribe,
    chatStore.connectionChannelsCollection.getSnapshot
  )
  const [selectedChannel, setSelectedChannel] = React.useState(null)
  const [wasChannelSelected, setWasChannelSelected] = React.useState(false)

  const router = useRouter()
  const { referrer } = router.query

  useEffect(() => {
    if (user?.email) {
      chatStore.init(user)
    }
  }, [user])

  useEffect(() => {
    if (
      chatState.status === ChatStatusType.INITIALIZED &&
      referrer &&
      wasChannelSelected === false
    ) {
      setWasChannelSelected(true)

      const channel = connectionChannels.find(
        (c) => c.url === `sendbird_group_channel_${referrer}`
      )

      if (channel && channel.url !== selectedChannel?.url) {
        setSelectedChannel(channel)
      }
    }
  }, [
    referrer,
    chatState,
    connectionChannels,
    router,
    selectedChannel?.url,
    wasChannelSelected,
  ])

  useEffect(() => {
    if (selectedChannel) {
      chatStore.selectChannel(selectedChannel)

      setSelectedChannel(null)

      // remove query param
      router.replace(router.pathname, undefined, { shallow: true })
    }
  }, [selectedChannel, router])

  return (
    <ChatStoreContext.Provider
      value={{
        hasUnreadMessages:
          chatState.dealChannelsUnreadMessagesCount > 0 ||
          chatState.connectionRequestChannelsUnreadMessagesCount > 0 ||
          chatState.connectionChannelsUnreadMessagesCount > 0,
        ...chatState,
      }}
    >
      <ChatSendMessageToastProvider>
        {children}
        <ChatSendMessageToast />
      </ChatSendMessageToastProvider>
    </ChatStoreContext.Provider>
  )
}

export default ChatStoreProvider
